module.exports = __webpack_public_path__ + "static/img/platinum.7578a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/leagueoflegends/ranks/platinum.png
// module id = PNhy
// module chunks = 35